import { ISharePanel } from '@models/ISharePanel';
import SharePanel from '@molecules/SharePanel/SharePanel';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';

const ArticleShare = (props: ISharePanel) => (
  <section>
    <SoftLoadWrapper>
      {/* //! TODO: Need aria-label values passing to share panel (share to Facebook, Twitter, etc.) */}
      <SharePanel {...props} />
    </SoftLoadWrapper>
  </section>
);

export default ArticleShare;
